<template>
  <div v-if="onlyAffectedServices.length > 0">
    <div>
      <service-info
        v-for="service in onlyAffectedServices"
        :service-info="service"/>
    </div>
  </div>
  <div v-else>Empty matching services</div>
</template>

<script>
    import _ from 'lodash'
    import ServiceInfo from './ServiceInfo'

    export default {
        name: 'services-info',
        components: {
            ServiceInfo
        },
        props: {
            log: {
                type: Array,
                required: true
            },
            affectedServices: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                eventTypeFilter: ['ChangeRequested', 'ChangeExecuted']
            }
        },
        computed: {
            affectedServicesMap() {
                let result = {};
                _.forEach(this.affectedServices.list, it => result[it.serviceId] = it);
                return result
            },
            services() {
                let grouped = _.groupBy(this.log, it => it.serviceId);
                let list = _.keys(grouped).map(it => {
                    let serviceLog = grouped[it];
                    let requestedLog = _.filter(serviceLog, it => it.event === 'ChangeRequested');
                    let executedLog = _.filter(serviceLog, it => it.event === 'ChangeExecuted');
                    let checkedLog = _.filter(serviceLog, it => it.event === 'ChangeChecked');

                    let requestedQuantity = _.reduce(requestedLog, (sum, logItem) => sum + logItem.quantityChange, 0);
                    let executedQuantity = _.reduce(executedLog, (sum, logItem) => sum + logItem.quantityChange, 0);
                    let checkedQuantity = _.reduce(checkedLog, (sum, logItem) => sum + logItem.quantityChange, 0);

                    let affectedServiceInfo = this.affectedServicesMap[it] || {};

                    return {
                        serviceId: it,
                        log: serviceLog,
                        requestedQuantityAllTime: requestedQuantity,
                        executedQuantityAllTime: executedQuantity,
                        checkedQuantityAllTime: checkedQuantity,
                        requestedQuantity: affectedServiceInfo.requestedQty || 0,
                        executedQuantity: affectedServiceInfo.executedQty || 0,
                        checkedQuantity: affectedServiceInfo.checkedQty || 0,
                        affected: this.affectedServicesMap[it],
                    }
                });

                return list
            },
            onlyAffectedServices() {
                return _.filter(this.services, s => s.affected)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/analytics/ServicesInfo.vue